import React from "react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Will my proprietary SOPs be used to train your AI?",
    a: "Contact us for the current data-handling terms that apply to your engagement.",
  },
  {
    q: "Can other LabComplyx customers see my data or suggestions?",
    a: "Absolutely not. Our architecture is built on tenant isolation. Each client has a dedicated, encrypted storage environment, and the AI retrieval engine is restricted to your specific database during your session — making it architecturally impossible for your lab's unique processes to leak into another customer's results.",
  },
  {
    q: "What happens if the AI makes a mistake in a compliance-critical record?",
    a: "No AI output enters a record of truth without documented human review. Every draft passes a human-in-the-loop compliance gate where a qualified reviewer verifies the content before it can be approved — and that verification is captured in the audit trail with the model version, prompt lineage, and reviewer sign-off.",
  },
  {
    q: "What if your AI provider goes down while I'm preparing a regulatory filing?",
    a: "Availability failures are treated as formal incidents under our AI Incident Response Plan. Your documents and audit records live in our own infrastructure — not the AI provider's — so completed work is never at risk, and drafting can resume the moment service is restored.",
  },
  {
    q: "Can I prove to an auditor how an AI-assisted document was created?",
    a: "Yes. Every AI generation event produces a runtime trace: model version, prompt version, cryptographic input/output hashes, timestamps, and the human verification decision. These traces are exportable as an evidence bundle for inspector review.",
  },
];

export default function SecurityAIFAQ() {
  return (
    <section className="py-16 bg-background">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <h2 className="text-2xl font-bold text-foreground mb-2">Security &amp; AI — straight answers</h2>
        <p className="text-sm text-muted-foreground mb-8">
          The questions lab managers ask us most about putting AI near regulated work.
        </p>
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`}>
              <AccordionTrigger className="text-left text-sm font-semibold">{f.q}</AccordionTrigger>
              <AccordionContent className="text-sm text-muted-foreground leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}